import { IContact } from '.';
import { IState } from '..';
import { formatStringToPhone } from '../../utils/regex';

export function getContactName(contact: IContact | undefined): string {
  let name = 'Unknown Contact';
  if (contact) {
    name = `${contact.firstName} ${contact.lastName}`;
  }
  return name;
}

export function getContactNameString(state: IState, contactIds: number[]): string {
  return contactIds
    .map(id => getContactName(state.contacts.hash[id]))
    .filter(x => x)
    .join(', ');
}

export function getContact(state: IState, contactId: number, businessEntityId: number): IContact {
  return contactId === -1 ? newContact(businessEntityId) : contactWithFormattedPhones(state.contacts.hash[contactId]);
}

function contactWithFormattedPhones(contact: IContact): IContact {
  return {
    ...contact,
    mobilePhone: formatStringToPhone(contact.mobilePhone),
    phone: formatStringToPhone(contact.phone)
  };
}

function newContact(businessEntityId: number): IContact {
  return {
    authorizationEmail: '',
    axContactId: '',
    businessEntityId,
    contactId: -1,
    dealerPortalEnabled: false,
    email: '',
    firstName: '',
    inactive: false,
    lastName: '',
    mobilePhone: '',
    phone: '',
    prefEmail: false,
    prefPhone: false,
    prefText: false,
    title: ''
  };
}
